import { createContext, useContext } from "react";


export const UpdateSelector = createContext<{ updater: boolean; setUpdater: React.Dispatch<React.SetStateAction<boolean>> } | undefined>(undefined);

export const useUpdater = () => {
  const context = useContext(UpdateSelector);
  if (!context) {
    throw new Error('useUpdater must be used within a UpdateSelector.provider');
  }
  return context;
};